var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 375 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#createDiscountBlendSvg)",
    d: "M90.498 36.646c-12.352 27.328-16.812 21.11-38.51 16.098C30.29 47.73 17.122 71.398 23.709 88.88c6.588 17.483 37.305 28.441 20.515 47.515-16.79 19.075-40.071 24.477-40.81 43.23-.739 18.752 26.227 22.088 22.266 32.577-3.96 10.488-52.993 32.944-4.195 41.738 48.798 8.795 289.3 1.92 330.455-7.512 41.155-9.431 18.063-56.378.92-78.891-17.143-22.513 29.2-51.946 7.34-86.351-21.861-34.406-89.42-6.916-122.433-40.06-33.014-33.144-49.819-46.428-90.564-39.222-40.744 7.207-56.705 34.742-56.705 34.742z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    d: "M81.425 256.09c-21.803 0-30.317-6.483-30.317-9.466 0 0-.916-5.408 1.698-5.408 0 0 16.85 5.554 28.038 5.554 16.979 0 29.043-5.554 29.043-5.554 2.599 0 1.713 2.443 1.713 5.408 0 2.98-8.452 9.466-30.175 9.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    d: "M111.799 242.993c0-4.455-13.589-8.064-30.35-8.064-16.761 0-30.347 3.609-30.347 8.064 0 4.456 13.595 9.005 30.356 9.005 16.761 0 30.341-4.549 30.341-9.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    d: "M109.173 242.721c0-3.621-12.086-6.562-26.994-6.562s-26.99 2.941-26.99 6.562c0 3.622 12.092 7.329 27 7.329 14.907 0 26.984-3.704 26.984-7.329z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M108.544 243.024c0-3.475-11.659-6.291-26.038-6.291-14.38 0-26.041 2.819-26.041 6.291 0 3.472 11.665 7.023 26.047 7.023 14.383 0 26.032-3.548 26.032-7.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    d: "M89.896 245.53c1.09-.501 2.137-1.27 2.464-2.119.486-1.264-.953-2.104-3.441-2.247-2.309-.135-3.823.305-5.604 1.526-2.027 1.478-4.489 2.324-7.967 2.138-3.844-.223-6.226-1.625-5.496-3.484a4.028 4.028 0 012.024-2.046l2.47.491c-.561.288-1.526.883-1.871 1.75-.504 1.307 1.32 1.921 3.005 2.016 2.305.134 3.664-.382 5.496-1.625 2.232-1.527 4.565-2.235 8.19-2.024 3.808.219 6.684 1.505 5.802 3.762-.354.916-1.438 1.893-2.513 2.351l-2.56-.489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    d: "M71.775 241.301l-.397 1.032-3.936-.229.397-1.029 3.936.226zM97.117 242.783l-.397 1.029-3.936-.229.397-1.029 3.936.229z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M88.969 249.94c-21.803 0-30.316-6.483-30.316-9.467 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.598 0 1.713 2.443 1.713 5.408 0 2.984-8.453 9.467-30.176 9.467z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M119.344 236.846c0-4.455-13.589-8.068-30.35-8.068-16.761 0-30.347 3.613-30.347 8.068s13.595 9.002 30.356 9.002c16.761 0 30.341-4.547 30.341-9.002z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M116.718 236.574c0-3.625-12.086-6.562-26.994-6.562s-26.99 2.937-26.99 6.562c0 3.625 12.091 7.329 27 7.329 14.907 0 26.984-3.704 26.984-7.329z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M116.087 236.876c0-3.475-11.658-6.29-26.038-6.29s-26.04 2.815-26.04 6.29 11.664 7.024 26.046 7.024c14.383 0 26.032-3.561 26.032-7.024z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M97.439 239.371c1.09-.504 2.138-1.271 2.464-2.138.486-1.264-.953-2.101-3.441-2.244-2.309-.135-3.823.305-5.603 1.527-2.028 1.478-4.49 2.323-7.967 2.137-3.845-.223-6.227-1.621-5.497-3.484a4.038 4.038 0 012.022-2.046l2.47.492c-.562.287-1.527.885-1.872 1.749-.504 1.307 1.32 1.921 3.005 2.019 2.305.134 3.664-.382 5.496-1.628 2.233-1.527 4.58-2.232 8.19-2.021 3.811.22 6.684 1.502 5.802 3.762-.357.916-1.441 1.89-2.516 2.351l-2.553-.476z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M79.31 235.148l-.397 1.029-3.936-.226.397-1.032 3.936.229zM104.655 236.62l-.397 1.03-3.936-.226.397-1.029 3.936.225z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M79.466 245.469c-21.802 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.554 28.038 5.554 16.978 0 29.043-5.554 29.043-5.554 2.599 0 1.713 2.443 1.713 5.408 0 2.983-8.452 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M109.847 232.372c0-4.455-13.588-8.064-30.346-8.064-16.759 0-30.35 3.612-30.35 8.064s13.595 9.005 30.356 9.005c16.761 0 30.34-4.55 30.34-9.005z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M107.215 232.094c0-3.624-12.083-6.562-26.99-6.562-14.908 0-26.994 2.938-26.994 6.562 0 3.625 12.092 7.329 27 7.329 14.907 0 26.984-3.698 26.984-7.329z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M106.585 232.4c0-3.475-11.659-6.291-26.038-6.291-14.38 0-26.038 2.819-26.038 6.291 0 3.472 11.665 7.023 26.047 7.023 14.383 0 26.029-3.545 26.029-7.023z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M87.936 234.898c1.093-.501 2.138-1.267 2.465-2.119.485-1.264-.95-2.104-3.442-2.248-2.305-.134-3.823.306-5.6 1.527-2.03 1.478-4.489 2.324-7.97 2.122-3.845-.222-6.226-1.624-5.497-3.484a4.038 4.038 0 012.022-2.046l2.47.492c-.558.287-1.526.883-1.872 1.75-.503 1.307 1.32 1.92 3.005 2.018 2.306.131 3.665-.385 5.497-1.627 2.235-1.527 4.58-2.236 8.193-2.025 3.807.22 6.68 1.505 5.801 3.762-.357.916-1.441 1.893-2.516 2.354l-2.556-.476z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M69.817 230.681l-.397 1.032-3.936-.229.397-1.029 3.936.226zM95.16 232.15l-.398 1.029-3.933-.229.397-1.029 3.933.229z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M84.777 239.042c-21.802 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.554 28.038 5.554 16.978 0 29.043-5.554 29.043-5.554 2.599 0 1.713 2.443 1.713 5.408 0 2.983-8.464 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M115.152 225.945c0-4.455-13.589-8.064-30.35-8.064-16.761 0-30.347 3.612-30.347 8.064 0 4.453 13.595 9.006 30.356 9.006 16.762 0 30.341-4.55 30.341-9.006z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M112.526 225.682c0-3.624-12.086-6.562-26.99-6.562-14.905 0-26.995 2.938-26.995 6.562 0 3.625 12.093 7.329 27 7.329 14.908 0 26.985-3.713 26.985-7.329z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M111.896 225.988c0-3.475-11.659-6.291-26.038-6.291-14.38 0-26.042 2.819-26.042 6.291 0 3.472 11.665 7.023 26.048 7.023 14.382 0 26.032-3.561 26.032-7.023z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M93.247 228.471c1.094-.501 2.138-1.268 2.465-2.12.485-1.264-.95-2.103-3.442-2.247-2.305-.134-3.823.305-5.6 1.527-2.03 1.478-4.489 2.324-7.97 2.137-3.845-.223-6.226-1.624-5.497-3.484a4.029 4.029 0 012.022-2.046l2.47.492c-.562.287-1.526.882-1.872 1.75-.503 1.307 1.32 1.92 3.005 2.018 2.306.131 3.665-.385 5.497-1.628 2.235-1.526 4.58-2.235 8.19-2.024 3.81.22 6.684 1.505 5.801 3.762-.357.916-1.441 1.893-2.516 2.354l-2.553-.491z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M75.128 224.253l-.397 1.032-3.936-.229.397-1.029 3.936.226zM100.47 225.722l-.397 1.029-3.936-.229.397-1.029 3.936.229z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M85.611 230.656c-21.802 0-30.313-6.482-30.313-9.466 0 0-.9-5.408 1.698-5.408 0 0 16.847 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.596 0 1.713 2.443 1.713 5.408 0 2.984-8.455 9.466-30.179 9.466z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M115.985 217.563c0-4.455-13.589-8.068-30.347-8.068-16.758 0-30.347 3.613-30.347 8.068s13.595 9.002 30.356 9.002c16.762 0 30.338-4.547 30.338-9.002z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M113.362 217.291c0-3.625-12.086-6.562-26.993-6.562-14.908 0-26.991 2.937-26.991 6.562 0 3.624 12.092 7.328 27 7.328 14.907 0 26.984-3.704 26.984-7.328z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M112.734 217.593c0-3.475-11.659-6.29-26.042-6.29-14.382 0-26.038 2.815-26.038 6.29s11.665 7.023 26.048 7.023c14.382 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M94.085 220.088c1.09-.504 2.138-1.27 2.465-2.137.485-1.264-.953-2.101-3.442-2.248-2.309-.131-3.823.306-5.603 1.527-2.028 1.478-4.49 2.324-7.967 2.122-3.845-.223-6.227-1.621-5.497-3.484a4.046 4.046 0 012.025-2.046l2.467.492c-.559.287-1.527.885-1.869 1.75-.504 1.307 1.32 1.92 3.005 2.018 2.306.134 3.665-.385 5.497-1.628 2.232-1.526 4.58-2.232 8.19-2.021 3.807.22 6.684 1.502 5.801 3.762-.354.916-1.438 1.89-2.513 2.351l-2.559-.458z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M75.966 215.871l-.397 1.029-3.936-.229.397-1.029 3.936.229zM101.295 217.336l-.397 1.03-3.936-.226.397-1.033 3.936.229z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M213.374 256.649c21.803 0 30.317-6.483 30.317-9.467 0 0 .897-5.408-1.698-5.408 0 0-16.85 5.555-28.038 5.555-16.978 0-29.043-5.555-29.043-5.555-2.599 0-1.713 2.443-1.713 5.408 0 2.981 8.452 9.467 30.175 9.467z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M183 243.552c0-4.455 13.588-8.065 30.35-8.065 16.761 0 30.347 3.61 30.347 8.065s-13.595 9.005-30.356 9.005c-16.762 0-30.341-4.55-30.341-9.005z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M185.626 243.283c0-3.625 12.086-6.562 26.993-6.562 14.908 0 26.991 2.937 26.991 6.562 0 3.625-12.092 7.329-27 7.329-14.907 0-26.984-3.708-26.984-7.329z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M186.256 243.582c0-3.475 11.659-6.29 26.038-6.29 14.38 0 26.041 2.818 26.041 6.29s-11.664 7.024-26.047 7.024c-14.382 0-26.032-3.549-26.032-7.024z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M204.901 246.077c-1.09-.501-2.137-1.267-2.464-2.119-.485-1.264.953-2.104 3.442-2.248 2.308-.134 3.823.306 5.603 1.527 2.027 1.478 4.489 2.324 7.967 2.138 3.844-.223 6.226-1.625 5.496-3.484a4.02 4.02 0 00-2.021-2.046l-2.471.491c.562.287 1.527.883 1.872 1.75.504 1.307-1.319 1.921-3.005 2.019-2.305.131-3.664-.385-5.496-1.628-2.232-1.527-4.58-2.235-8.19-2.025-3.808.22-6.684 1.506-5.802 3.762.355.917 1.439 1.894 2.513 2.352l2.556-.489z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M223.024 241.867l.397 1.032 3.936-.229-.397-1.029-3.936.226zM197.682 243.329l.397 1.029 3.936-.229-.397-1.029-3.936.229z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M220.369 250.499c21.803 0 30.316-6.483 30.316-9.466 0 0 .898-5.408-1.698-5.408 0 0-16.85 5.555-28.038 5.555-16.978 0-29.043-5.555-29.043-5.555-2.598 0-1.713 2.443-1.713 5.408.006 2.971 8.459 9.466 30.176 9.466z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M190.001 237.406c0-4.456 13.588-8.068 30.349-8.068 16.762 0 30.347 3.612 30.347 8.068 0 4.455-13.594 9.002-30.356 9.002-16.761 0-30.34-4.541-30.34-9.002z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M192.627 237.133c0-3.624 12.086-6.562 26.993-6.562 14.908 0 26.991 2.938 26.991 6.562 0 3.625-12.092 7.329-27 7.329-14.907 0-26.984-3.704-26.984-7.329z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M193.255 237.436c0-3.475 11.659-6.29 26.039-6.29 14.379 0 26.041 2.815 26.041 6.29s-11.665 7.023-26.048 7.023c-14.382 0-26.032-3.548-26.032-7.023z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M211.904 239.93c-1.09-.504-2.138-1.27-2.464-2.137-.486-1.264.952-2.101 3.441-2.245 2.308-.134 3.823.306 5.603 1.527 2.028 1.481 4.489 2.324 7.967 2.138 3.845-.223 6.226-1.622 5.497-3.484a4.039 4.039 0 00-2.025-2.046l-2.47.491c.562.287 1.527.886 1.872 1.75.503 1.307-1.32 1.921-3.005 2.018-2.306.135-3.664-.381-5.497-1.627-2.232-1.527-4.58-2.232-8.189-2.022-3.808.22-6.685 1.503-5.802 3.762.354.916 1.438 1.891 2.513 2.352l2.559-.477z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M230.025 235.713l.397 1.029 3.936-.226-.397-1.032-3.936.229zM204.683 237.18l.397 1.029 3.936-.226-.397-1.029-3.936.226z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M218.376 244.071c21.802 0 30.316-6.482 30.316-9.466 0 0 .898-5.408-1.701-5.408 0 0-16.847 5.555-28.038 5.555-16.978 0-29.043-5.555-29.043-5.555-2.596 0-1.713 2.443-1.713 5.408 0 2.987 8.464 9.466 30.179 9.466z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M188.001 230.978c0-4.455 13.588-8.068 30.347-8.068 16.758 0 30.35 3.613 30.35 8.068s-13.598 9.002-30.356 9.002c-16.759 0-30.341-4.55-30.341-9.002z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M190.628 230.706c0-3.625 12.083-6.562 26.991-6.562 14.907 0 26.991 2.937 26.991 6.562 0 3.624-12.093 7.328-26.997 7.328-14.905 0-26.985-3.704-26.985-7.328z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M191.257 231.008c0-3.475 11.655-6.29 26.038-6.29 14.382 0 26.038 2.815 26.038 6.29s-11.665 7.024-26.047 7.024c-14.383 0-26.029-3.549-26.029-7.024z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M209.905 233.503c-1.093-.504-2.137-1.27-2.464-2.137-.486-1.264.95-2.101 3.441-2.248 2.306-.131 3.82.306 5.601 1.527 2.03 1.478 4.489 2.324 7.967 2.122 3.847-.223 6.226-1.621 5.496-3.484a4.045 4.045 0 00-2.024-2.046l-2.468.492c.559.287 1.527.885 1.872 1.75.501 1.307-1.322 1.92-3.005 2.018-2.308.134-3.664-.385-5.496-1.627-2.235-1.527-4.581-2.233-8.193-2.022-3.808.22-6.684 1.502-5.802 3.762.354.916 1.438 1.89 2.516 2.351l2.559-.458z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M228.022 229.286l.397 1.029 3.936-.229-.397-1.029-3.936.229zM202.681 230.752l.394 1.038 3.936-.226-.397-1.032-3.933.22z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M224.553 237.925c21.802 0 30.316-6.483 30.316-9.466 0 0 .898-5.408-1.698-5.408 0 0-16.85 5.554-28.038 5.554-16.978 0-29.043-5.554-29.043-5.554-2.599 0-1.713 2.443-1.713 5.408 0 2.98 8.452 9.466 30.176 9.466z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M194.178 224.828c0-4.455 13.589-8.064 30.35-8.064 16.761 0 30.347 3.609 30.347 8.064s-13.595 9.005-30.356 9.005c-16.761 0-30.341-4.55-30.341-9.005z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M196.804 224.556c0-3.624 12.086-6.562 26.994-6.562 14.907 0 26.991 2.938 26.991 6.562 0 3.625-12.093 7.329-27 7.329-14.908 0-26.985-3.704-26.985-7.329z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M197.434 224.859c0-3.475 11.659-6.291 26.038-6.291 14.38 0 26.042 2.819 26.042 6.291 0 3.472-11.665 7.023-26.048 7.023-14.382 0-26.032-3.548-26.032-7.023z",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M234.215 223.136l.397 1.032 3.936-.229-.397-1.029-3.936.226zM208.87 224.605l.397 1.029 3.936-.229-.397-1.029-3.936.229z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M219.375 233.451c21.803 0 30.316-6.483 30.316-9.466 0 0 .916-5.408-1.698-5.408 0 0-16.85 5.555-28.038 5.555-16.978 0-29.043-5.555-29.043-5.555-2.598 0-1.713 2.443-1.713 5.408 0 2.983 8.452 9.466 30.176 9.466z",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M189.001 220.358c0-4.456 13.588-8.065 30.35-8.065 16.761 0 30.347 3.609 30.347 8.065 0 4.455-13.595 9.002-30.356 9.002-16.762 0-30.341-4.547-30.341-9.002z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M191.627 220.086c0-3.625 12.086-6.563 26.993-6.563 14.908 0 26.991 2.938 26.991 6.563 0 3.624-12.092 7.328-27 7.328-14.907 0-26.984-3.704-26.984-7.328z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M192.255 220.388c0-3.475 11.659-6.29 26.042-6.29 14.382 0 26.038 2.815 26.038 6.29s-11.665 7.023-26.048 7.023c-14.382 0-26.032-3.56-26.032-7.023z",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M210.904 222.882c-1.09-.504-2.138-1.27-2.464-2.137-.486-1.264.952-2.101 3.441-2.245 2.308-.134 3.823.306 5.603 1.527 2.028 1.481 4.489 2.324 7.967 2.138 3.845-.223 6.226-1.622 5.497-3.481a4.024 4.024 0 00-2.025-2.046l-2.47.488c.562.287 1.527.886 1.872 1.75.503 1.307-1.32 1.921-3.005 2.018-2.306.135-3.664-.381-5.497-1.627-2.232-1.527-4.58-2.232-8.189-2.022-3.808.22-6.685 1.503-5.802 3.762.354.916 1.438 1.891 2.513 2.352l2.559-.477z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M229.022 218.66l.397 1.029 3.936-.226-.397-1.032-3.936.229zM203.676 220.131l.397 1.029 3.936-.226-.397-1.029-3.936.226z",
    clipRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M225.375 224.787c21.803 0 30.317-6.483 30.317-9.466 0 0 .897-5.408-1.698-5.408 0 0-16.85 5.555-28.038 5.555-16.978 0-29.043-5.555-29.043-5.555-2.599 0-1.713 2.443-1.713 5.408 0 2.983 8.452 9.466 30.175 9.466z",
    clipRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M195.001 211.694c0-4.456 13.588-8.068 30.347-8.068 16.758 0 30.35 3.612 30.35 8.068 0 4.455-13.598 9.002-30.356 9.002-16.759 0-30.341-4.55-30.341-9.002z",
    clipRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M197.612 211.422c0-3.625 12.086-6.563 26.991-6.563 14.904 0 26.994 2.938 26.994 6.563 0 3.624-12.093 7.328-27 7.328-14.908 0-26.985-3.704-26.985-7.328z",
    clipRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M198.257 211.724c0-3.475 11.659-6.29 26.038-6.29 14.38 0 26.041 2.815 26.041 6.29s-11.664 7.023-26.047 7.023c-14.382 0-26.032-3.548-26.032-7.023z",
    clipRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M216.905 214.219c-1.093-.504-2.137-1.27-2.464-2.122-.485-1.265.95-2.101 3.442-2.248 2.305-.131 3.823.306 5.6 1.527 2.031 1.478 4.489 2.324 7.97 2.137 3.844-.222 6.226-1.621 5.496-3.484a4.05 4.05 0 00-2.021-2.046l-2.47.492c.558.287 1.526.886 1.871 1.75.504 1.307-1.319 1.92-3.004 2.018-2.309.135-3.665-.385-5.497-1.627-2.235-1.527-4.58-2.233-8.193-2.022-3.808.22-6.681 1.502-5.802 3.762.358.916 1.439 1.89 2.517 2.351l2.555-.488z",
    clipRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M235.025 210.001l.397 1.03 3.936-.229-.397-1.03-3.936.229zM209.683 211.467l.397 1.029 3.933-.226-.397-1.032-3.933.229z",
    clipRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M239.927 219.478c21.803 0 30.316-6.483 30.316-9.467 0 0 .898-5.407-1.698-5.407 0 0-16.849 5.554-28.041 5.554-16.978 0-29.04-5.554-29.04-5.554-2.598 0-1.713 2.442-1.713 5.407 0 2.984 8.453 9.467 30.176 9.467z",
    clipRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M209.552 206.384c0-4.455 13.589-8.068 30.347-8.068 16.758 0 30.35 3.613 30.35 8.068s-13.595 9.002-30.356 9.002c-16.761 0-30.341-4.547-30.341-9.002z",
    clipRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M212.178 206.112c0-3.625 12.083-6.562 26.991-6.562s26.994 2.937 26.994 6.562c0 3.625-12.092 7.329-27 7.329s-26.985-3.704-26.985-7.329z",
    clipRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M212.808 206.414c0-3.475 11.659-6.29 26.038-6.29 14.38 0 26.039 2.815 26.039 6.29s-11.665 7.024-26.048 7.024c-14.382 0-26.029-3.549-26.029-7.024z",
    clipRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M231.468 208.909c-1.093-.504-2.137-1.27-2.464-2.122-.486-1.264.95-2.101 3.441-2.244 2.306-.135 3.824.305 5.601 1.526 2.03 1.478 4.489 2.324 7.97 2.138 3.844-.223 6.226-1.622 5.496-3.484a4.046 4.046 0 00-2.021-2.046l-2.471.491c.559.287 1.527.886 1.872 1.75.504 1.307-1.319 1.921-3.005 2.019-2.308.134-3.664-.382-5.496-1.628-2.235-1.527-4.581-2.232-8.193-2.022-3.808.22-6.684 1.503-5.802 3.763.354.916 1.438 1.89 2.516 2.351l2.556-.492z",
    clipRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M249.576 204.692l.397 1.029 3.933-.226-.397-1.032-3.933.229zM224.234 206.159l.397 1.029 3.933-.226-.397-1.029-3.933.226z",
    clipRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M224.375 213.89c21.803 0 30.317-6.483 30.317-9.466 0 0 .897-5.408-1.698-5.408 0 0-16.85 5.554-28.041 5.554-16.978 0-29.043-5.554-29.043-5.554-2.596 0-1.713 2.443-1.713 5.408 0 2.98 8.455 9.466 30.178 9.466z",
    clipRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M194.001 200.793c0-4.455 13.588-8.064 30.347-8.064 16.758 0 30.35 3.609 30.35 8.064s-13.598 9.005-30.356 9.005c-16.759 0-30.341-4.55-30.341-9.005z",
    clipRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M196.627 200.524c0-3.625 12.083-6.562 26.99-6.562 14.908 0 26.994 2.937 26.994 6.562 0 3.625-12.092 7.329-27 7.329-14.907 0-26.984-3.707-26.984-7.329z",
    clipRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M197.257 200.824c0-3.475 11.658-6.291 26.038-6.291 14.379 0 26.038 2.819 26.038 6.291 0 3.472-11.665 7.023-26.047 7.023-14.383 0-26.029-3.539-26.029-7.023z",
    clipRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M215.905 203.319c-1.093-.501-2.137-1.267-2.464-2.119-.486-1.264.95-2.104 3.441-2.248 2.306-.134 3.82.306 5.601 1.527 2.03 1.478 4.489 2.324 7.967 2.122 3.847-.223 6.226-1.624 5.496-3.484a4.039 4.039 0 00-2.021-2.046l-2.471.492c.559.287 1.527.882 1.872 1.75.504 1.307-1.319 1.92-3.005 2.018-2.308.131-3.664-.385-5.496-1.627-2.235-1.527-4.565-2.236-8.193-2.025-3.808.22-6.684 1.505-5.802 3.762.354.916 1.438 1.893 2.516 2.351l2.559-.473z",
    clipRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M234.025 199.117l.397 1.032 3.933-.229-.397-1.029-3.933.226zM208.68 200.57l.397 1.029 3.936-.229-.397-1.029-3.936.229z",
    clipRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M296.759 256.649c-21.803 0-30.317-6.483-30.317-9.467 0 0-.897-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.599 0 1.713 2.443 1.713 5.408 0 2.981-8.452 9.467-30.175 9.467z",
    clipRule: "evenodd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M327.133 243.552c0-4.455-13.588-8.065-30.35-8.065-16.761 0-30.346 3.61-30.346 8.065s13.594 9.005 30.355 9.005c16.762 0 30.341-4.55 30.341-9.005z",
    clipRule: "evenodd"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M324.507 243.283c0-3.625-12.086-6.562-26.993-6.562-14.908 0-26.991 2.937-26.991 6.562 0 3.625 12.092 7.329 27 7.329 14.907 0 26.984-3.708 26.984-7.329z",
    clipRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M323.877 243.582c0-3.475-11.659-6.29-26.038-6.29-14.38 0-26.041 2.818-26.041 6.29s11.664 7.024 26.047 7.024c14.382 0 26.032-3.549 26.032-7.024z",
    clipRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M305.232 246.077c1.09-.501 2.137-1.267 2.464-2.119.485-1.264-.953-2.104-3.441-2.248-2.309-.134-3.824.306-5.604 1.527-2.027 1.478-4.489 2.324-7.967 2.138-3.844-.223-6.226-1.625-5.496-3.484a4.02 4.02 0 012.021-2.046l2.471.491c-.562.287-1.527.883-1.872 1.75-.504 1.307 1.319 1.921 3.005 2.019 2.305.131 3.664-.385 5.496-1.628 2.232-1.527 4.58-2.235 8.19-2.025 3.808.22 6.684 1.506 5.802 3.762-.355.917-1.439 1.894-2.513 2.352l-2.556-.489z",
    clipRule: "evenodd"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M287.109 241.867l-.397 1.032-3.936-.229.397-1.029 3.936.226zM312.451 243.329l-.397 1.029-3.936-.229.397-1.029 3.936.229z",
    clipRule: "evenodd"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M284.466 250.499c-21.802 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.599 0 1.713 2.443 1.713 5.408-.006 2.971-8.458 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M314.835 237.406c0-4.456-13.589-8.068-30.35-8.068-16.762 0-30.347 3.612-30.347 8.068 0 4.455 13.595 9.002 30.356 9.002 16.761 0 30.341-4.541 30.341-9.002z",
    clipRule: "evenodd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M312.209 237.133c0-3.624-12.087-6.562-26.994-6.562-14.908 0-26.991 2.938-26.991 6.562 0 3.625 12.092 7.329 27 7.329s26.985-3.704 26.985-7.329z",
    clipRule: "evenodd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M311.58 237.436c0-3.475-11.659-6.29-26.038-6.29-14.38 0-26.042 2.815-26.042 6.29s11.665 7.023 26.048 7.023c14.382 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M292.931 239.93c1.091-.504 2.138-1.27 2.465-2.137.485-1.264-.953-2.101-3.442-2.245-2.308-.134-3.823.306-5.603 1.527-2.028 1.481-4.489 2.324-7.967 2.138-3.844-.223-6.226-1.622-5.496-3.484a4.037 4.037 0 012.024-2.046l2.47.491c-.561.287-1.526.886-1.871 1.75-.504 1.307 1.319 1.921 3.004 2.018 2.306.135 3.665-.381 5.497-1.627 2.232-1.527 4.58-2.232 8.19-2.022 3.807.22 6.684 1.503 5.801 3.762-.354.916-1.438 1.891-2.513 2.352l-2.559-.477z",
    clipRule: "evenodd"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M274.81 235.713l-.397 1.029-3.936-.226.397-1.032 3.936.229zM300.153 237.18l-.397 1.029-3.936-.226.397-1.029 3.936.226z",
    clipRule: "evenodd"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M294.206 244.071c-21.803 0-30.316-6.482-30.316-9.466 0 0-.898-5.408 1.701-5.408 0 0 16.847 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.595 0 1.713 2.443 1.713 5.408 0 2.987-8.465 9.466-30.179 9.466z",
    clipRule: "evenodd"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M324.581 230.978c0-4.455-13.589-8.068-30.347-8.068-16.758 0-30.35 3.613-30.35 8.068s13.598 9.002 30.356 9.002c16.758 0 30.341-4.55 30.341-9.002z",
    clipRule: "evenodd"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M321.954 230.706c0-3.625-12.083-6.562-26.991-6.562s-26.991 2.937-26.991 6.562c0 3.624 12.092 7.328 26.997 7.328s26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M321.325 231.008c0-3.475-11.656-6.29-26.038-6.29-14.383 0-26.038 2.815-26.038 6.29s11.665 7.024 26.047 7.024c14.383 0 26.029-3.549 26.029-7.024z",
    clipRule: "evenodd"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M302.677 233.503c1.093-.504 2.137-1.27 2.464-2.137.485-1.264-.95-2.101-3.442-2.248-2.305-.131-3.82.306-5.6 1.527-2.031 1.478-4.489 2.324-7.967 2.122-3.847-.223-6.226-1.621-5.496-3.484a4.045 4.045 0 012.024-2.046l2.468.492c-.559.287-1.527.885-1.872 1.75-.501 1.307 1.322 1.92 3.004 2.018 2.309.134 3.665-.385 5.497-1.627 2.235-1.527 4.58-2.233 8.193-2.022 3.808.22 6.684 1.502 5.802 3.762-.355.916-1.439 1.89-2.517 2.351l-2.558-.458z",
    clipRule: "evenodd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M284.56 229.286l-.397 1.029-3.936-.229.397-1.029 3.936.229zM309.901 230.752l-.394 1.038-3.936-.226.397-1.032 3.933.22z",
    clipRule: "evenodd"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M285.581 237.924c-21.803 0-30.317-6.483-30.317-9.466 0 0-.897-5.408 1.698-5.408 0 0 16.85 5.554 28.038 5.554 16.978 0 29.043-5.554 29.043-5.554 2.599 0 1.713 2.443 1.713 5.408 0 2.98-8.452 9.466-30.175 9.466z",
    clipRule: "evenodd"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M315.955 224.827c0-4.455-13.588-8.064-30.35-8.064-16.761 0-30.346 3.609-30.346 8.064s13.594 9.005 30.355 9.005c16.762 0 30.341-4.55 30.341-9.005z",
    clipRule: "evenodd"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M313.329 224.555c0-3.624-12.086-6.562-26.993-6.562-14.908 0-26.991 2.938-26.991 6.562 0 3.625 12.092 7.329 27 7.329 14.907 0 26.984-3.704 26.984-7.329z",
    clipRule: "evenodd"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M312.699 224.858c0-3.475-11.659-6.291-26.038-6.291-14.38 0-26.041 2.819-26.041 6.291 0 3.472 11.664 7.023 26.047 7.023 14.382 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M275.918 223.135l-.397 1.032-3.936-.229.397-1.029 3.936.226zM301.263 224.604l-.396 1.029-3.937-.229.397-1.029 3.936.229z",
    clipRule: "evenodd"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M290.212 233.45c-21.803 0-30.316-6.483-30.316-9.466 0 0-.917-5.408 1.697-5.408 0 0 16.85 5.555 28.039 5.555 16.978 0 29.042-5.555 29.042-5.555 2.599 0 1.714 2.443 1.714 5.408 0 2.983-8.453 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M320.586 220.357c0-4.456-13.589-8.065-30.35-8.065-16.761 0-30.347 3.609-30.347 8.065 0 4.455 13.595 9.002 30.356 9.002 16.761 0 30.341-4.547 30.341-9.002z",
    clipRule: "evenodd"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M317.96 220.085c0-3.625-12.086-6.563-26.994-6.563s-26.991 2.938-26.991 6.563c0 3.624 12.093 7.328 27 7.328 14.908 0 26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M317.331 220.387c0-3.475-11.658-6.29-26.041-6.29-14.382 0-26.038 2.815-26.038 6.29s11.665 7.023 26.047 7.023c14.383 0 26.032-3.56 26.032-7.023z",
    clipRule: "evenodd"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M298.683 222.881c1.09-.503 2.137-1.27 2.464-2.137.486-1.264-.953-2.101-3.441-2.245-2.309-.134-3.823.306-5.604 1.527-2.027 1.481-4.488 2.324-7.967 2.138-3.844-.223-6.226-1.622-5.496-3.481a4.016 4.016 0 012.025-2.046l2.47.488c-.562.287-1.527.886-1.872 1.75-.504 1.307 1.319 1.921 3.005 2.018 2.305.135 3.664-.381 5.496-1.627 2.232-1.527 4.581-2.232 8.19-2.022 3.808.22 6.684 1.503 5.802 3.762-.354.917-1.438 1.891-2.513 2.352l-2.559-.477z",
    clipRule: "evenodd"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M280.565 218.659l-.397 1.029-3.936-.226.397-1.032 3.936.229zM305.91 220.13l-.397 1.029-3.936-.226.397-1.029 3.936.226z",
    clipRule: "evenodd"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M298.206 224.787c-21.802 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.599 0 1.713 2.443 1.713 5.408 0 2.983-8.452 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M328.581 211.694c0-4.456-13.589-8.068-30.347-8.068-16.758 0-30.35 3.612-30.35 8.068 0 4.455 13.598 9.002 30.356 9.002 16.758 0 30.341-4.55 30.341-9.002z",
    clipRule: "evenodd"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M325.97 211.422c0-3.625-12.086-6.563-26.991-6.563s-26.994 2.938-26.994 6.563c0 3.624 12.092 7.328 27 7.328s26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M325.325 211.724c0-3.475-11.659-6.29-26.038-6.29-14.38 0-26.042 2.815-26.042 6.29s11.665 7.023 26.048 7.023c14.382 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M306.676 214.219c1.093-.504 2.138-1.27 2.465-2.122.485-1.265-.95-2.101-3.442-2.248-2.305-.131-3.823.306-5.6 1.527-2.031 1.478-4.489 2.324-7.97 2.137-3.845-.222-6.226-1.621-5.497-3.484a4.052 4.052 0 012.022-2.046l2.47.492c-.559.287-1.527.886-1.872 1.75-.503 1.307 1.32 1.92 3.005 2.018 2.309.135 3.664-.385 5.497-1.627 2.235-1.527 4.58-2.233 8.192-2.022 3.808.22 6.682 1.502 5.802 3.762-.357.916-1.438 1.89-2.516 2.351l-2.556-.488z",
    clipRule: "evenodd"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M288.557 210.001l-.397 1.03-3.936-.229.397-1.03 3.936.229zM313.899 211.467l-.397 1.029-3.933-.226.397-1.032 3.933.229z",
    clipRule: "evenodd"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M162.749 256.649c-21.802 0-30.316-6.483-30.316-9.467 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.599 0 1.713 2.443 1.713 5.408 0 2.981-8.452 9.467-30.176 9.467z",
    clipRule: "evenodd"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M193.124 243.552c0-4.455-13.589-8.065-30.35-8.065-16.761 0-30.347 3.61-30.347 8.065s13.595 9.005 30.356 9.005c16.761 0 30.341-4.55 30.341-9.005z",
    clipRule: "evenodd"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M190.498 243.283c0-3.625-12.086-6.562-26.994-6.562-14.907 0-26.991 2.937-26.991 6.562 0 3.625 12.093 7.329 27 7.329 14.908 0 26.985-3.708 26.985-7.329z",
    clipRule: "evenodd"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M189.868 243.582c0-3.475-11.659-6.29-26.038-6.29-14.38 0-26.042 2.818-26.042 6.29s11.665 7.024 26.048 7.024c14.382 0 26.032-3.549 26.032-7.024z",
    clipRule: "evenodd"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M171.222 246.077c1.091-.501 2.138-1.267 2.465-2.119.485-1.264-.953-2.104-3.442-2.248-2.308-.134-3.823.306-5.603 1.527-2.028 1.478-4.489 2.324-7.967 2.138-3.844-.223-6.226-1.625-5.496-3.484a4.016 4.016 0 012.021-2.046l2.47.491c-.561.287-1.526.883-1.871 1.75-.504 1.307 1.319 1.921 3.004 2.019 2.306.131 3.665-.385 5.497-1.628 2.232-1.527 4.58-2.235 8.19-2.025 3.807.22 6.684 1.506 5.801 3.762-.354.917-1.438 1.894-2.513 2.352l-2.556-.489z",
    clipRule: "evenodd"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M153.1 241.867l-.397 1.032-3.936-.229.397-1.029 3.936.226zM178.442 243.329l-.397 1.029-3.936-.229.397-1.029 3.936.229z",
    clipRule: "evenodd"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M150.457 250.498c-21.803 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.697-5.408 0 0 16.85 5.555 28.039 5.555 16.978 0 29.043-5.555 29.043-5.555 2.598 0 1.713 2.443 1.713 5.408-.007 2.971-8.459 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M180.825 237.405c0-4.456-13.589-8.068-30.35-8.068-16.761 0-30.347 3.612-30.347 8.068 0 4.455 13.595 9.002 30.356 9.002 16.762 0 30.341-4.541 30.341-9.002z",
    clipRule: "evenodd"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M178.199 237.133c0-3.625-12.086-6.563-26.994-6.563s-26.991 2.938-26.991 6.563c0 3.624 12.093 7.328 27 7.328 14.908 0 26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M177.57 237.435c0-3.475-11.658-6.29-26.038-6.29-14.379 0-26.041 2.815-26.041 6.29s11.665 7.023 26.047 7.023c14.383 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M158.922 239.929c1.09-.504 2.137-1.27 2.464-2.137.486-1.264-.953-2.101-3.441-2.245-2.309-.134-3.823.306-5.604 1.527-2.027 1.481-4.488 2.324-7.967 2.138-3.844-.223-6.226-1.622-5.496-3.484a4.039 4.039 0 012.025-2.046l2.47.491c-.562.287-1.527.886-1.872 1.75-.504 1.307 1.319 1.921 3.005 2.018 2.305.135 3.664-.381 5.496-1.627 2.232-1.527 4.581-2.232 8.19-2.022 3.808.22 6.684 1.503 5.802 3.762-.354.916-1.438 1.891-2.513 2.352l-2.559-.477z",
    clipRule: "evenodd"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M140.801 235.712l-.397 1.029-3.936-.225.397-1.033 3.936.229zM166.143 237.179l-.397 1.029-3.936-.226.397-1.029 3.936.226z",
    clipRule: "evenodd"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M150.73 244.07c-21.802 0-30.316-6.482-30.316-9.466 0 0-.898-5.408 1.701-5.408 0 0 16.847 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.596 0 1.713 2.443 1.713 5.408 0 2.987-8.464 9.466-30.179 9.466z",
    clipRule: "evenodd"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M181.105 230.977c0-4.455-13.589-8.068-30.347-8.068-16.758 0-30.35 3.613-30.35 8.068s13.598 9.002 30.356 9.002c16.759 0 30.341-4.55 30.341-9.002z",
    clipRule: "evenodd"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M178.478 230.705c0-3.625-12.083-6.562-26.991-6.562s-26.991 2.937-26.991 6.562c0 3.624 12.093 7.328 26.997 7.328 14.905 0 26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M177.849 231.007c0-3.475-11.655-6.29-26.038-6.29-14.382 0-26.038 2.815-26.038 6.29s11.665 7.024 26.047 7.024c14.383 0 26.029-3.549 26.029-7.024z",
    clipRule: "evenodd"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M159.201 233.502c1.093-.504 2.137-1.27 2.464-2.137.485-1.264-.95-2.101-3.441-2.248-2.306-.131-3.821.306-5.601 1.527-2.03 1.478-4.489 2.324-7.967 2.122-3.847-.222-6.226-1.621-5.496-3.484a4.045 4.045 0 012.024-2.046l2.468.492c-.559.287-1.527.886-1.872 1.75-.501 1.307 1.322 1.92 3.005 2.018 2.308.134 3.664-.385 5.496-1.627 2.235-1.527 4.581-2.233 8.193-2.022 3.808.22 6.684 1.502 5.802 3.762-.354.916-1.438 1.89-2.516 2.351l-2.559-.458z",
    clipRule: "evenodd"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M141.084 229.285l-.397 1.029-3.936-.229.397-1.029 3.936.229zM166.425 230.751l-.394 1.038-3.936-.226.397-1.032 3.933.22z",
    clipRule: "evenodd"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M151.571 237.924c-21.803 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.849 5.554 28.038 5.554 16.978 0 29.043-5.554 29.043-5.554 2.598 0 1.713 2.443 1.713 5.408 0 2.98-8.453 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M181.946 224.827c0-4.455-13.589-8.064-30.35-8.064-16.761 0-30.347 3.609-30.347 8.064s13.595 9.005 30.356 9.005c16.761 0 30.341-4.55 30.341-9.005z",
    clipRule: "evenodd"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M179.32 224.555c0-3.624-12.086-6.562-26.994-6.562s-26.991 2.938-26.991 6.562c0 3.625 12.093 7.329 27 7.329 14.908 0 26.985-3.704 26.985-7.329z",
    clipRule: "evenodd"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M178.689 224.858c0-3.475-11.658-6.291-26.038-6.291-14.379 0-26.041 2.819-26.041 6.291 0 3.472 11.665 7.023 26.047 7.023 14.383 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M141.909 223.135l-.397 1.032-3.936-.229.397-1.029 3.936.226zM167.254 224.604l-.397 1.029-3.936-.229.397-1.029 3.936.229z",
    clipRule: "evenodd"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M161.631 233.45c-21.803 0-30.316-6.483-30.316-9.466 0 0-.917-5.408 1.697-5.408 0 0 16.85 5.555 28.039 5.555 16.978 0 29.042-5.555 29.042-5.555 2.599 0 1.714 2.443 1.714 5.408 0 2.983-8.453 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M192.005 220.357c0-4.456-13.589-8.065-30.35-8.065-16.761 0-30.347 3.609-30.347 8.065 0 4.455 13.595 9.002 30.356 9.002 16.761 0 30.341-4.547 30.341-9.002z",
    clipRule: "evenodd"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M189.379 220.085c0-3.625-12.086-6.563-26.994-6.563s-26.991 2.938-26.991 6.563c0 3.624 12.093 7.328 27 7.328 14.908 0 26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M188.75 220.387c0-3.475-11.658-6.29-26.041-6.29-14.382 0-26.038 2.815-26.038 6.29s11.665 7.023 26.047 7.023c14.383 0 26.032-3.56 26.032-7.023z",
    clipRule: "evenodd"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M170.102 222.881c1.09-.503 2.137-1.27 2.464-2.137.486-1.264-.953-2.101-3.441-2.245-2.309-.134-3.823.306-5.604 1.527-2.027 1.481-4.489 2.324-7.967 2.138-3.844-.223-6.226-1.622-5.496-3.481a4.018 4.018 0 012.024-2.046l2.471.488c-.562.287-1.527.886-1.872 1.75-.504 1.307 1.319 1.921 3.005 2.018 2.305.135 3.664-.381 5.496-1.627 2.232-1.527 4.581-2.232 8.19-2.022 3.808.22 6.684 1.503 5.802 3.762-.354.917-1.438 1.891-2.513 2.352l-2.559-.477z",
    clipRule: "evenodd"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M151.984 218.659l-.397 1.029-3.936-.226.397-1.032 3.936.229zM177.329 220.13l-.397 1.029-3.936-.226.397-1.029 3.936.226z",
    clipRule: "evenodd"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M146.817 224.786c-21.802 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.698-5.408 0 0 16.85 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.599 0 1.713 2.443 1.713 5.408 0 2.983-8.452 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M177.192 211.693c0-4.456-13.589-8.068-30.347-8.068-16.758 0-30.35 3.612-30.35 8.068 0 4.455 13.598 9.002 30.356 9.002 16.759 0 30.341-4.55 30.341-9.002z",
    clipRule: "evenodd"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M174.581 211.421c0-3.625-12.086-6.563-26.991-6.563s-26.994 2.938-26.994 6.563c0 3.624 12.092 7.328 27 7.328s26.985-3.704 26.985-7.328z",
    clipRule: "evenodd"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M173.936 211.723c0-3.475-11.659-6.29-26.038-6.29-14.38 0-26.042 2.815-26.042 6.29s11.665 7.023 26.048 7.023c14.382 0 26.032-3.548 26.032-7.023z",
    clipRule: "evenodd"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M155.287 214.218c1.094-.504 2.138-1.27 2.465-2.122.485-1.265-.95-2.101-3.442-2.248-2.305-.131-3.823.306-5.6 1.527-2.031 1.478-4.489 2.324-7.97 2.138-3.845-.223-6.226-1.622-5.497-3.485a4.052 4.052 0 012.022-2.046l2.47.492c-.558.287-1.526.886-1.872 1.75-.503 1.307 1.32 1.92 3.005 2.018 2.309.135 3.665-.385 5.497-1.627 2.235-1.527 4.58-2.233 8.193-2.022 3.807.22 6.681 1.503 5.801 3.762-.357.916-1.438 1.89-2.516 2.351l-2.556-.488z",
    clipRule: "evenodd"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M137.168 210.001l-.397 1.029-3.936-.229.397-1.03 3.936.23zM162.51 211.466l-.397 1.029-3.933-.226.397-1.032 3.933.229z",
    clipRule: "evenodd"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M136.197 219.477c-21.803 0-30.316-6.483-30.316-9.467 0 0-.898-5.407 1.697-5.407 0 0 16.85 5.554 28.042 5.554 16.978 0 29.04-5.554 29.04-5.554 2.598 0 1.713 2.442 1.713 5.407 0 2.984-8.453 9.467-30.176 9.467z",
    clipRule: "evenodd"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M166.571 206.383c0-4.455-13.588-8.068-30.346-8.068-16.759 0-30.35 3.613-30.35 8.068s13.594 9.002 30.356 9.002c16.761 0 30.34-4.547 30.34-9.002z",
    clipRule: "evenodd"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M163.946 206.111c0-3.625-12.083-6.562-26.991-6.562s-26.994 2.937-26.994 6.562c0 3.625 12.092 7.329 27 7.329s26.985-3.704 26.985-7.329z",
    clipRule: "evenodd"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M163.316 206.413c0-3.475-11.659-6.29-26.039-6.29-14.379 0-26.038 2.815-26.038 6.29s11.665 7.024 26.048 7.024c14.382 0 26.029-3.549 26.029-7.024z",
    clipRule: "evenodd"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M144.656 208.908c1.093-.504 2.137-1.27 2.464-2.122.485-1.264-.95-2.101-3.442-2.244-2.305-.135-3.823.305-5.6 1.526-2.031 1.478-4.489 2.324-7.97 2.138-3.844-.223-6.226-1.622-5.496-3.484a4.043 4.043 0 012.021-2.046l2.471.491c-.559.287-1.527.886-1.872 1.75-.504 1.307 1.319 1.921 3.004 2.019 2.309.134 3.665-.382 5.497-1.628 2.235-1.527 4.58-2.232 8.193-2.021 3.808.219 6.684 1.502 5.802 3.762-.355.916-1.439 1.89-2.517 2.351l-2.555-.492z",
    clipRule: "evenodd"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M126.548 204.691l-.397 1.029-3.933-.226.396-1.032 3.934.229zM151.89 206.158l-.397 1.029-3.933-.226.397-1.029 3.933.226z",
    clipRule: "evenodd"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M155.481 213.889c-21.803 0-30.316-6.483-30.316-9.466 0 0-.898-5.408 1.697-5.408 0 0 16.85 5.554 28.042 5.554 16.978 0 29.043-5.554 29.043-5.554 2.595 0 1.713 2.443 1.713 5.408 0 2.98-8.456 9.466-30.179 9.466z",
    clipRule: "evenodd"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M185.855 200.792c0-4.455-13.588-8.064-30.346-8.064-16.759 0-30.35 3.609-30.35 8.064s13.597 9.005 30.356 9.005c16.758 0 30.34-4.55 30.34-9.005z",
    clipRule: "evenodd"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M183.23 200.523c0-3.624-12.083-6.562-26.991-6.562s-26.994 2.938-26.994 6.562c0 3.625 12.092 7.329 27 7.329s26.985-3.707 26.985-7.329z",
    clipRule: "evenodd"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M182.599 200.823c0-3.475-11.658-6.291-26.038-6.291-14.379 0-26.038 2.819-26.038 6.291 0 3.472 11.665 7.023 26.047 7.023 14.383 0 26.029-3.539 26.029-7.023z",
    clipRule: "evenodd"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M163.951 203.318c1.093-.501 2.137-1.267 2.464-2.119.486-1.264-.949-2.104-3.441-2.248-2.306-.134-3.82.306-5.601 1.527-2.03 1.478-4.488 2.324-7.966 2.122-3.848-.223-6.227-1.624-5.497-3.484a4.037 4.037 0 012.022-2.046l2.47.492c-.559.287-1.527.882-1.872 1.75-.504 1.307 1.319 1.92 3.005 2.018 2.308.131 3.664-.385 5.496-1.627 2.236-1.527 4.565-2.236 8.193-2.025 3.808.22 6.685 1.505 5.802 3.762-.354.916-1.438 1.893-2.516 2.351l-2.559-.473z",
    clipRule: "evenodd"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M145.831 199.116l-.396 1.032-3.934-.229.397-1.029 3.933.226zM171.177 200.569l-.397 1.029-3.936-.229.396-1.029 3.937.229z",
    clipRule: "evenodd"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M144.303 209.137c-21.803 0-30.317-6.483-30.317-9.466 0 0-.897-5.408 1.701-5.408 0 0 16.847 5.554 28.038 5.554 16.979 0 29.043-5.554 29.043-5.554 2.596 0 1.713 2.443 1.713 5.408 0 2.983-8.449 9.466-30.178 9.466z",
    clipRule: "evenodd"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M174.677 196.04c0-4.452-13.588-8.064-30.346-8.064-16.759 0-30.35 3.612-30.35 8.064s13.597 9.005 30.356 9.005c16.758 0 30.34-4.55 30.34-9.005z",
    clipRule: "evenodd"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M172.05 195.771c0-3.624-12.083-6.562-26.991-6.562-14.907 0-26.99 2.938-26.99 6.562 0 3.625 12.092 7.329 26.997 7.329 14.904 0 26.984-3.707 26.984-7.329z",
    clipRule: "evenodd"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M171.421 196.062c0-3.472-11.655-6.291-26.038-6.291-14.382 0-26.038 2.819-26.038 6.291 0 3.472 11.665 7.023 26.048 7.023 14.382 0 26.028-3.539 26.028-7.023z",
    clipRule: "evenodd"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M152.773 198.568c1.093-.503 2.137-1.27 2.464-2.122.486-1.264-.949-2.104-3.441-2.247-2.306-.135-3.82.305-5.601 1.527-2.03 1.478-4.488 2.323-7.966 2.137-3.848-.223-6.227-1.624-5.497-3.484a4.031 4.031 0 012.025-2.046l2.467.492c-.559.287-1.527.882-1.872 1.749-.501 1.307 1.322 1.921 3.005 2.019 2.308.131 3.664-.385 5.496-1.628 2.236-1.527 4.581-2.232 8.193-2.024 3.808.22 6.685 1.505 5.802 3.765-.354.916-1.438 1.89-2.516 2.351l-2.559-.489z",
    clipRule: "evenodd"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M134.657 194.348l-.397 1.032-3.937-.229.397-1.029 3.937.226zM159.999 195.817l-.397 1.029-3.936-.229.396-1.029 3.937.229z",
    clipRule: "evenodd"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M155.205 202.987c-21.803 0-30.316-6.482-30.316-9.466 0 0-.916-5.408 1.698-5.408 0 0 16.849 5.555 28.038 5.555 16.978 0 29.043-5.555 29.043-5.555 2.595 0 1.713 2.443 1.713 5.408 0 2.984-8.453 9.466-30.176 9.466z",
    clipRule: "evenodd"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M185.578 189.894c0-4.456-13.589-8.065-30.347-8.065-16.758 0-30.347 3.609-30.347 8.065 0 4.455 13.595 9.002 30.356 9.002 16.761 0 30.338-4.547 30.338-9.002z",
    clipRule: "evenodd"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M182.953 189.622c0-3.625-12.086-6.562-26.994-6.562-14.907 0-26.99 2.937-26.99 6.562 0 3.624 12.092 7.328 27 7.328 14.907 0 26.984-3.704 26.984-7.328z",
    clipRule: "evenodd"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M182.324 189.924c0-3.475-11.658-6.29-26.041-6.29-14.382 0-26.038 2.815-26.038 6.29s11.665 7.024 26.047 7.024c14.383 0 26.032-3.549 26.032-7.024z",
    clipRule: "evenodd"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M163.675 192.419c1.09-.504 2.137-1.27 2.464-2.122.486-1.265-.952-2.101-3.441-2.245-2.309-.134-3.823.306-5.604 1.527-2.027 1.481-4.488 2.324-7.966 2.137-3.845-.219-6.227-1.621-5.512-3.481a4.022 4.022 0 012.024-2.046l2.468.489c-.559.287-1.527.886-1.869 1.75-.504 1.307 1.319 1.92 3.005 2.018 2.305.135 3.664-.382 5.496-1.627 2.232-1.527 4.581-2.233 8.19-2.022 3.808.22 6.684 1.506 5.802 3.762-.354.916-1.439 1.89-2.513 2.351l-2.544-.491z",
    clipRule: "evenodd"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M145.555 188.202l-.397 1.029-3.936-.226.397-1.032 3.936.229zM170.897 189.667l-.397 1.032-3.936-.229.397-1.029 3.936.226z",
    clipRule: "evenodd"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD529",
    fillRule: "evenodd",
    d: "M160.229 192.926c-21.803 0-30.317-6.48-30.317-9.466 0 0-.897-5.411 1.698-5.411 0 0 16.85 5.557 28.038 5.557 16.978 0 29.043-5.557 29.043-5.557 2.599 0 1.713 2.443 1.713 5.411.003 2.983-8.449 9.466-30.175 9.466z",
    clipRule: "evenodd"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC200",
    fillRule: "evenodd",
    d: "M190.607 179.832c0-4.455-13.589-8.064-30.347-8.064-16.758 0-30.35 3.609-30.35 8.064s13.595 9.002 30.356 9.002c16.761 0 30.341-4.547 30.341-9.002z",
    clipRule: "evenodd"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    fillRule: "evenodd",
    d: "M187.979 179.573c0-3.625-12.086-6.562-26.991-6.562-14.904 0-26.994 2.937-26.994 6.562 0 3.625 12.093 7.329 27 7.329 14.908 0 26.985-3.717 26.985-7.329z",
    clipRule: "evenodd"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    fillRule: "evenodd",
    d: "M187.35 179.878c0-3.475-11.658-6.29-26.038-6.29-14.379 0-26.041 2.818-26.041 6.29s11.665 7.024 26.047 7.024c14.383 0 26.032-3.564 26.032-7.024z",
    clipRule: "evenodd"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M168.702 182.358c1.093-.501 2.137-1.27 2.464-2.137.485-1.265-.95-2.101-3.441-2.245-2.306-.134-3.824.305-5.601 1.527-2.03 1.481-4.489 2.327-7.97 2.137-3.844-.222-6.226-1.624-5.496-3.484a4.039 4.039 0 012.021-2.046l2.471.492c-.559.287-1.527.882-1.872 1.75-.504 1.307 1.319 1.917 3.005 2.015 2.308.134 3.664-.382 5.496-1.627 2.235-1.527 4.58-2.233 8.193-2.022 3.808.22 6.681 1.505 5.802 3.762-.358.916-1.442 1.893-2.516 2.351l-2.556-.473z",
    clipRule: "evenodd"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE082",
    fillRule: "evenodd",
    d: "M150.582 178.14l-.397 1.029-3.936-.226.397-1.029 3.936.226zM175.925 179.606l-.397 1.032-3.933-.229.397-1.029 3.933.226z",
    clipRule: "evenodd"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CA92",
    fillRule: "evenodd",
    d: "M153.531 52.204l2.327-10.648 5.472.464.87 10.425-.275 6.559-8.394-6.8z",
    clipRule: "evenodd"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#000D3A",
    fillRule: "evenodd",
    d: "M110.696 39.201c-6.108 2.528-6.718 17.867 9.267 17.07 2.3-.113-5.429 4.492-1.456 8.474 5.353 5.365 17.793 6.412 26.316.042 4.275-3.185 2.62-14.51 8.513-15.463 1.252-.202 3.054-2.083 3.359-3.799.727-4.003 5.149-7.835 7.879-9.136 6.168-2.932 3.053-9.977-1.417-10.755-4.297-.748-7.677-1.555-10.627 2.165-2.574 3.246-1.744 5.893-3.71 6.324-1.356.305-3.17-1.222-6.883-1.09-7.857.26-8.55 5.032-10.324 7.023-4.492 5.041-10.407-5.225-20.917-.855z",
    clipRule: "evenodd"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4CA92",
    fillRule: "evenodd",
    d: "M168.249 180.919l-2.94-.419-6.043-8.244s-12.612-41.071-4.44-50.296c1.884-2.138 8.825-.193 8.825-.193l-1.194 49.014 5.792 10.138z",
    clipRule: "evenodd"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M159.214 175.297c.113.031.467 6.144.467 6.144l.611.031s.611-5.958.742-5.949c1.832.12 2.336 5.961 4.709 5.961.049 0 2.711.018 2.748 0 .553-.489-.769-1.527-.769-1.527s-1.646-.412-2.138-1.029c-1.664-2.018-4.07-6.397-4.614-6.971-.754-.794-2.018-.721-2.018-.721s-.788 3.777.262 4.061z",
    clipRule: "evenodd"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M156.417 172.357l5.615 8.498-2.406-.522-6.577-7.784s-13.647-42.665-8.792-48.711c1.783-2.217 11.378 0 11.378 0l.782 48.519z",
    clipRule: "evenodd"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    d: "M193.118 70.65l1.189-2.6 3.468 1.588-1.19 2.598z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M195.558 70.64c.223-1.22.611-1.981 3.102-1.398 1.564.363 1.298.812 1.075 2.025-.223 1.212-1.093 1.758-2.669 1.468-1.575-.29-1.719-.88-1.508-2.094z",
    clipRule: "evenodd"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#F05831",
    fillRule: "evenodd",
    d: "M194.786 71.725s-15.72-3.76-20.691-5.832c-1.402-.584-12.093-10.184-12.093-10.184s-1.239-5.42.275-6.27c2.923-1.642 17.1 11.055 17.1 11.055l16.185 7.347-.776 3.884z",
    clipRule: "evenodd"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8340E",
    fillRule: "evenodd",
    d: "M165.253 85.292l-19.106-2.4s-2.266-17.77-.476-26.289c.332-1.585 4.043-6.751 7.753-8.932.897-.528 7.686 5.533 7.686 5.533l.723-5.014c2.037 1.39 4.08 1.054 6.566 5.048 2.815 4.532 3.359 11.561 1.276 15.1-3.264 5.542-4.422 16.954-4.422 16.954z",
    clipRule: "evenodd"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M167.483 39.644c-.266.33-1.615-.59-1.637.412-.104 5.03-2.443 7.576-4.47 6.895-2.028-.68-2.974-2.269-4.202-3.026-.064-.04.873-2.354 1.096-4.238.122-1.017-1.386-3.75-.98-4.34 1.112-1.621 1.582.052 2.693-.027 5.011-.354 2.138-5.872 3.289-6.413.058-.027 2.837 3.997 2.828 7.38-.003 1.13 1.954 2.654 1.383 3.357z",
    clipRule: "evenodd"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M164.443 129.68c-3.195 2.4-17.531 4.932-22.826.654-4.382-3.543-1.6-11.143-1.732-17.311-.137-6.602-1.688-24.967 6.248-30.231.107-.07 5.207.66 5.326.672l13.771 1.801c3.063 1.716.904 43.145-.787 44.415z",
    clipRule: "evenodd"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M197.256 70.308c.687-1.221 1.222-1.975 2.08-1.334.531.4.69 1.3 0 2.513-.69 1.212-1.594 1.661-2.168 1.335-.574-.327-.599-1.298.088-2.514z",
    clipRule: "evenodd"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    fillRule: "evenodd",
    d: "M152.927 175.297c.113.031.467 6.144.467 6.144l.611.031s.611-5.958.742-5.949c1.832.12 2.336 5.961 4.706 5.961.051 0 2.711.018 2.748 0 .553-.489-.77-1.527-.77-1.527s-1.646-.412-2.152-1.029c-1.665-2.018-4.071-6.397-4.614-6.971-.758-.794-2.019-.721-2.019-.721s-.769 3.777.281 4.061z",
    clipRule: "evenodd"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#B2DFDB",
    fillRule: "evenodd",
    d: "M203.085 104.398c.125-1.45-5.521-53.132-5.521-53.132s-76.184 25.06-95.523 8.855c-.73-.61-2.091 67.268-2.091 67.268s100.83 3.301 103.135-22.991z",
    clipRule: "evenodd"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#00834E",
    fillRule: "evenodd",
    d: "M103.655 124.641c.113.006 6.068.271 14.923.271 8.141 0 18.75-.238 29.51-1.09 30.659-2.452 48.101-8.709 51.845-18.59v-.001c.195-.525.42-1.128-2.443-25.405a3963.037 3963.037 0 00-2.472-20.405c-.258-2.093-.414-3.356-.414-3.395l-.217-1.747-1.652.611a367.722 367.722 0 01-36.851 11.02c-25.183 5.983-42.091 6.27-48.894.831l-.69-.54-.785.36c-.867.4-.922 1.151-1.102 3.637a315.137 315.137 0 00-.361 6.351c-.226 4.617-.482 11.027-.787 19.055-.507 13.659-.941 27.461-.941 27.598l-.043 1.374 1.374.065zm44.231-3.604c-19.082 1.53-37.62 1.044-42.726.864.577-18.382 1.503-44.243 2.046-51.667 8.404 4.715 24.979 4.187 49.346-1.615 15.986-3.799 30.674-8.816 35.493-10.517 2.226 17.934 5.276 43.633 5.209 46.293-2.403 6.019-12.969 13.726-49.368 16.642z",
    clipRule: "evenodd"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#00834E",
    fillRule: "evenodd",
    d: "M145.909 103.504a11.885 11.885 0 006.177.791c3.383-.504 5.093-2.584 4.709-5.167-.355-2.394-1.927-3.558-5.582-4.376-4.401-.861-7.308-2.644-7.842-6.254-.592-3.988 2.272-7.444 7.249-8.183 2.623-.388 4.611-.064 5.851.415l-.513 2.834a10.27 10.27 0 00-5.045-.495c-3.496.52-4.516 2.806-4.256 4.553.357 2.394 2.088 3.359 5.826 4.186 4.58 1.026 7.097 2.791 7.655 6.553.587 3.952-1.832 7.806-7.875 8.703-2.47.367-5.274.046-6.779-.662l.425-2.898z",
    clipRule: "evenodd"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#00834E",
    fillRule: "evenodd",
    d: "M147.867 78.556l2.748-.41.611 4.083-2.749.41-.61-4.083zM151.771 104.854l2.748-.41.611 4.083-2.748.409-.611-4.082zM194.735 59.186a3.194 3.194 0 11-5.86-2.546.095.095 0 000-.034c.046-.104 1.854.046 3.359.712 1.414.629 2.532 1.77 2.501 1.868zM195.734 108.981a3.821 3.821 0 011.888-7.405l.21.061c.138.04.275 2.211-.268 4.095-.513 1.774-1.701 3.301-1.83 3.249zM109.999 69.114a3.194 3.194 0 01-5.341 3.505l-.031-.049c-.061-.097.629-2.293 2.01-3.178 1.306-.837 3.304-.36 3.362-.278zM103.248 118.988a3.193 3.193 0 015.429 1.272 3.196 3.196 0 01-.802 3.131c-.08.085-2.376-.07-3.564-1.203-1.121-1.072-1.139-3.124-1.063-3.2zM122.997 105.305a9.222 9.222 0 100-18.444 9.222 9.222 0 000 18.444zM180.279 96.984a9.222 9.222 0 100-18.444 9.222 9.222 0 000 18.444z",
    clipRule: "evenodd"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDFAE",
    fillRule: "evenodd",
    d: "M198.446 71c.122-1.859.336-3.096 1.735-2.815.873.174 1.584 1.17 1.459 3.03-.125 1.86-.962 2.928-1.832 2.867-.87-.061-1.487-1.219-1.362-3.081zM106.234 63.352c-.787-.04-1.577 0-2.357.119-.992.15-1.731.202-2.69.824-.718.468-.944 2.4-.773 3.033.794 2.956 3.469-.098 3.469-.098l2.351-.067v-3.811z",
    clipRule: "evenodd"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#F05831",
    fillRule: "evenodd",
    d: "M104.24 67.273l.034-3.909 20.034-3.053s26.597-13.51 29.391-12.645c.153.046-8.593 13.289-8.593 13.289l-17.466 6.107-23.4.211z",
    clipRule: "evenodd"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "createDiscountBlendSvg",
    x1: 152.05,
    x2: 195.008,
    y1: -23.171,
    y2: 243.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDiscount);
export default __webpack_public_path__ + "static/media/createDiscount.e8799d1267dd9f1f6f2f99c98d8afe2c.svg";
export { ForwardRef as ReactComponent };